import { FC } from 'react'
import HistorischeDataView from './HistorischeDataView'

const HistorischeDataStadList: FC = () => <HistorischeDataView mode="stad" />

export default HistorischeDataStadList
